var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparklingStar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 153,
    viewBox: "0 0 173 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.19 34.7336C125.932 40.2761 130.734 54.1887 124.91 65.7942L110.269 94.9722C104.446 106.578 90.194 111.497 78.4517 105.954L48.9852 92.0454C37.2429 86.5029 32.4409 72.5903 38.2644 60.9848C44.088 49.3793 58.3395 44.4603 70.0818 50.0029L78.2793 53.8722L82.3722 45.7155C88.1958 34.11 102.447 29.191 114.19 34.7336Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0332 6.38216C66.1775 3.90283 63.4249 2.60356 60.8851 3.48017C58.3454 4.35677 56.9803 7.0773 57.836 9.55663L62.1774 22.1346C63.0331 24.6139 65.7857 25.9132 68.3254 25.0366C70.8652 24.16 72.2303 21.4394 71.3746 18.9601L67.0332 6.38216Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.999 130.866C109.144 128.386 106.391 127.087 103.851 127.964C101.312 128.84 99.9465 131.561 100.802 134.04L105.144 146.618C105.999 149.098 108.752 150.397 111.292 149.52C113.831 148.644 115.197 145.923 114.341 143.444L109.999 130.866Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.887 52.9699C171.427 52.0933 172.792 49.3728 171.936 46.8934C171.08 44.4141 168.328 43.1148 165.788 43.9914L152.904 48.4385C150.364 49.3152 148.999 52.0357 149.855 54.515C150.71 56.9944 153.463 58.2936 156.003 57.417L168.887 52.9699Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2881 104.605C21.8278 103.728 23.193 101.008 22.3372 98.5284C21.4815 96.049 18.7289 94.7498 16.1891 95.6264L3.30474 100.073C0.765004 100.95 -0.600129 103.671 0.255627 106.15C1.11139 108.629 3.86397 109.929 6.40371 109.052L19.2881 104.605Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.421 6.81518C127.611 4.44217 126.63 1.59974 124.229 0.466443C121.828 -0.666859 118.917 0.338131 117.726 2.71114L115.648 6.85301C114.457 9.22602 115.438 12.0684 117.839 13.2017C120.24 14.335 123.152 13.3301 124.342 10.9571L126.421 6.81518Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5619 146.119C57.7527 143.746 56.7716 140.903 54.3706 139.77C51.9696 138.637 49.058 139.642 47.8672 142.015L45.7888 146.157C44.5981 148.53 45.5792 151.372 47.9801 152.505C50.3811 153.639 53.2928 152.634 54.4836 150.261L56.5619 146.119Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.536 115.021C158.937 116.154 161.848 115.149 163.039 112.776C164.23 110.403 163.249 107.561 160.848 106.427L156.657 104.449C154.256 103.316 151.344 104.321 150.154 106.694C148.963 109.067 149.944 111.909 152.345 113.043L156.536 115.021Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5772 48.5282C17.9782 49.6615 20.8899 48.6566 22.0806 46.2835C23.2714 43.9105 22.2903 41.0681 19.8893 39.9348L15.6986 37.9567C13.2977 36.8234 10.386 37.8284 9.19523 40.2014C8.00447 42.5744 8.98555 45.4169 11.3865 46.5502L15.5772 48.5282Z",
    fill: "#4242CE",
    fillOpacity: 0.1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklingStar);
export default __webpack_public_path__ + "static/media/sparkling-star.e3876bd9bdd5e4f6dc3d591ea8d05723.svg";
export { ForwardRef as ReactComponent };